import { AppContextFactory } from '@ninja/utilities';
import { APIFactoryOptions, GlobalAPIError } from '@shory-health-individual/customer-api';

interface IAppContextExtend {
	apiConnectionOptions: APIFactoryOptions;
	liveChatWidgetProvider: {
		startChat: () => void;
	};
	onGeneralErrorHandling: (error: GlobalAPIError) => Promise<void>;
	userEmail: string | undefined;
}

const appFactory = new AppContextFactory<IAppContextExtend>();

export const { AppPlatformContextProvider, useAppPlatformContextOptions } = appFactory;
